// extracted by mini-css-extract-plugin
module.exports = {"sub-title":"SavedFilters_sub-title__3GcPB","sub-panel":"SavedFilters_sub-panel__2_4C0"};